<template lang="pug">
    .products-template
        .products-template-title
            p   {{ lenguageSelected.content1 }}
        .products-template-content
            .products-template-content-description
                p(v-for="item in lenguageSelected.content2")  {{ item }}
                
</template>


<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'ES',
            lenguageEN: {
                content1: 'Site Development (New builds)',
                content2: [
                    'ATP works with municipalities, carriers, and site acquisition resources across Colombia, Peru, Chile and Ecuador  to build new sites in strategic areas. We secure locations that resolve coverage gaps and capacity concerns. ',
                    'Having built hundreds of new sites throughout the region, our teams provide carrier clients with fast, flexible, and creative solutions. ATP is capable of managing build-to-suit projects of any scale with ease and expertise, and we have established a reputation for delivering projects on time, and on budget.',
                    'To learn more about our build-to-suit services, click the “Contact Us” button to your left.'
                ]
            },

            lenguageES: {
                content1: 'Desarrollo de Sitios (Nuevas construcciones)',
                content2: [
                    'ATP trabaja con municipios, operadores de telefonía celular y con recursos de gestión y adquisición de sitios en Colombia, Perú, Chile y Ecuador para la construcción de sitios en áreas estratégicas. Aseguramos ubicaciones que resuelven brechas de cobertura y problemas de capacidad.',
                    'Al haber construido cientos de sitios nuevos en toda la región andina, nuestros equipos proporcionan soluciones rápidas, flexibles y creativas. ATP es capaz de administrar proyectos de construcción a la medida de cualquier escala con facilidad y experiencia, y trabajamos construyendo una reputación de entrega de proyectos a tiempo y dentro de presupuesto.',
                    'Para obtener más información sobre nuestros servicios de construcción de sitios a la medida, seleccione el boton de la izquierda para ir a la sección de contacto.'
                ]
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmWeBuild.vue